module.exports = "/_next/static/images/6253f39d17ce3efd6c3b16bee9413449-website-thumb.jpg.webp";